import React from 'react';
import logo from "../assets/images/ARCIUM_Final_Brand_LANDSCAPE-removebg-preview.png"
import fb from "../assets/images/svgs/fb white.png"
import insta from "../assets/images/svgs/insta.png"
import tiktok from "../assets/images/svgs/tiktok-outline-svgrepo-com.png"
import wp from "../assets/images/svgs/whats-app-whatsapp-whatsapp-icon-svgrepo-com.png"

const Footer = () => {
  return (
    <footer className="footer bg-buttonHover flex flex-col items-center gap-8 p-6 font-roboto">
      <div className="flex items-center gap-2 text-xl font-bold hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer">
      <img src={logo} alt="" className="h-10"/>
      </div>
      <aside>
        <p className='font-bold hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer'>©{new Date().getFullYear()} Arcium Studio</p>
      </aside>
      <nav className="flex justify-between w-auto gap-10">
        <a className="link link-hover hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" href="/impressum">
          Help
        </a>
        <a className="link link-hover hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" href="/datenschutzerklärung">
          Policy
        </a>
      </nav>
      <div className="flex h-5 gap-10">
        <a href="https://www.facebook.com/profile.php?id=61571370176605" className="link hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" aria-label="Github Link">
          <img src={fb} className='w-6' alt="" />
        </a>
        <a href="https://www.instagram.com/arcium_studio/" className="link hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" aria-label="Facebook Link">
            <img src={insta} className='w-6' alt="" />
        </a>
        <a href="https://wa.me/37745541556" className="link hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" aria-label="X Link">
            <img src={wp} className='w-6' alt="" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
